export const LOGO = '/images/sunstone-logo.png';

export const DASHBOARD_HRIS =
  'https://storage.readdy-site.link/project_files/8782ad04-8180-4b09-b38a-b9f9956f127e/12d31d4a-e69c-42dc-bb0e-f2fb480654c3_hris-dashboard-mockup-1.jpg?v=654189589d1feaa5e7fcec4f8c0a837a';

export const DASHBOARD_OMS =
  'https://storage.readdy-site.link/project_files/8782ad04-8180-4b09-b38a-b9f9956f127e/0f7dbe84-385c-4e25-a6ad-88ce46cea91b_thl-dashboard-mockup-1.jpg?v=eb5d1639fbcb39fb5b12565b8025a460';

export const photos = {
  hero: '/images/sunstone-hero-office.jpg',
  managedIt: '/images/sunstone-managed-it.jpg',
  cybersecurity: '/images/sunstone-cybersecurity.jpg',
  cloud: '/images/sunstone-cloud.jpg',
  consulting: '/images/sunstone-consulting.jpg',
  infrastructure: '/images/sunstone-infrastructure.jpg',
  disasterRecovery: '/images/sunstone-disaster-recovery.jpg',
  team: '/images/sunstone-team.jpg',
} as const;

export const photoFrame =
  'rounded-3xl overflow-hidden border border-black/[0.06] shadow-[0_18px_50px_rgba(0,0,0,0.10)]';
